export default __webpack_public_path__ + "be6453d25391e3db9212fd49b0da70ad.png";